import BaseModule from '@/store/baseModule';
import treatsProperties from '@/business/apiTreatment/response/properties';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import marketTypes, {
  PURPOSE_LIST,
} from '@/store/modules/properties/constants';
import { getLogbookEntriesNumber } from '@/services/services/logbooks.service';
import { getEnergyCases } from '@/services/services/alerts.service';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import registerAlerts from './alerts';
import registerTypes from './types';
import registerQualifications from './qualifications';
import registerRequests from './requests';
import registerInterventions from './interventions';

const attributesObjRef = {
  type: {
    serverSide: true,
    values: [
      { id: 'C', name: 'Installation contractuelle' },
      { id: 'N', name: 'Point négoce' },
    ],
  },
  active: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  p1_monitoring: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  m2m_remotemanagement_enabled: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  market_type: {
    ...marketTypes,
    values: marketTypes.values.map((item) => ({ ...item, shortname: item.id })),
  },
  purpose: {
    serverSide: true,
    autocomplete: true,
    values: PURPOSE_LIST,
  },
};

function SET_ENERGY_CASES(state, casesList) {
  let items = state.items.data;
  items = items.map((item) => ({
    ...item,
    energy_cases: casesList.find((energy) => energy.property_id === item.id),
  }));
  state.items.data = items;
}

function SET_LOG_ENTRIES(state, logEntries) {
  let items = state.items.data;
  items = state.items.data.map((item) => {
    const data = logEntries.find((el) => el.property === item.id);
    return {
      ...item,
      nbEntries: data.nb_entries,
      nbActions: data.nb_actions,
      nbActionplans: data.nb_actionplans,
    };
  });
  state.items.data = items;
}

export default (store) => {
  store.registerModule(
    'properties',
    new BaseModule({
      sortChoices: ['shortname', 'city', 'code', 'entity_id'],
      searchAttributesArray: [
        'code',
        'shortname',
        'name',
        'city',
        'postal_code',
        'street',
      ],
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/properties`,
        }),
        treatListResponse: treatsProperties,
      }),
      makeQueryParams: makeListRequest({
        useEntities: true,
      }),
      customMutations: {
        SET_LOG_ENTRIES,
        SET_ENERGY_CASES,
      },
      attributesObjRef,
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    basePlugin.persistVuexMutationsToLocalStorage([
      'SET_ATTRIBUTES_OBJ',
      'SET_ITEMS_SORT_BY',
      'SET_VIEW_TABLE',
      'SET_ORDER_ASC',
    ]);

    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch(`properties/setGlobalSearch`, null);
      }
    });
    basePlugin.onItemsLoaded((items) => {
      const idx = items.map((item) => item.id);
      getLogbookEntriesNumber(idx)
        .then(async (resultList) => {
          store.commit('properties/SET_LOG_ENTRIES', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
      getEnergyCases(idx)
        .then(async (resultList) => {
          store.commit('properties/SET_ENERGY_CASES', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
    });
  });
  registerAlerts(store);
  registerTypes(store);
  registerQualifications(store);
  registerRequests(store);
  registerInterventions(store);
};
